function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 23C14.1349 23 16.5628 22.1139 18.502 20.6233L21.5355 23.6569C21.9261 24.0474 22.5592 24.0474 22.9497 23.6569L23.6569 22.9498C24.0474 22.5592 24.0474 21.9261 23.6569 21.5356L20.6233 18.502C22.1139 16.5628 23 14.1349 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM11.5001 20C16.1945 20 20.0001 16.1944 20.0001 11.5C20.0001 6.80554 16.1945 2.99996 11.5001 2.99996C6.80566 2.99996 3.00008 6.80554 3.00008 11.5C3.00008 16.1944 6.80566 20 11.5001 20ZM12.0911 10.1971C13.7335 10.9745 15.4667 11.795 15.4667 13.9302C15.4686 15.7809 14.2456 16.8319 12.6667 17.1952V18.5H12.2667H11.2H10.8V17.3162C9.82367 17.2407 8.8388 16.9616 8 16.4875L8.48533 14.5695C9.50507 15.0035 10.8619 15.4632 11.9253 15.1995C13.1509 14.895 13.4016 13.516 12.0469 12.8533C11.8616 12.759 11.605 12.6672 11.3103 12.5618C10.026 12.1022 8.01707 11.3833 8.01707 9.06983C8.01707 7.58513 8.9832 6.24587 10.8 5.82121V4.5H11.2H12.2667H12.6667V5.70988C13.3349 5.76457 14.0687 5.9113 14.8725 6.17883L14.4864 8.10033C13.6672 7.78533 12.7616 7.4995 11.8805 7.55783C10.2923 7.65933 10.1525 9.16317 11.2608 9.79317C11.5287 9.93085 11.8085 10.0633 12.0911 10.1971Z"
});

function SvgDdReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#E5E7EB",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdReport);
export default __webpack_public_path__ + "static/media/ddReport.d5c3c5e05c6b801e55b3089855450f3c.svg";
export { ForwardRef as ReactComponent };